let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7BiYh")).then(() => parcelRequire('dH96e'));